//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  // props:['lat','lng'],
  data: function data() {
    return {
      map: '北京',
      zoom: null,
      usermap: {
        lat: 116.403829,
        lng: 39.915158,
        address: '',
        addressComponents: {}
      }
    };
  },
  methods: {
    mapLoad: function mapLoad(e) {
      var _this = this;

      this.usermap.lat = e.point.lat;
      this.usermap.lng = e.point.lng;
      this.zoom = e.target.getZoom();
      var geocoder = new BMap.Geocoder(); //创建地址解析器的实例

      geocoder.getLocation(e.point, function (rs) {
        _this.usermap.address = rs.address;
        _this.usermap.addressComponents = rs.addressComponents;
      });
      console.log(this.usermap);
    },
    activeBtn: function activeBtn() {
      this.$emit("callFather");
    }
  },
  watch: {
    usermap: {
      handler: function handler(val, oldval) {
        this.activeBtn();
      },
      deep: true
    }
  }
};